import { StyleSheet } from 'react-native';

import { primitive, spacing } from 'styles/constants';

export const styles = StyleSheet.create({
  mainCard: {
    position: 'relative',
    borderRadius: 12,
    backgroundColor: primitive.$white,
  },
  progressContainer: {
    padding: spacing.$4,
  },
});
